module.exports = __webpack_public_path__ + "static/logo-5e93a163f9ec23d6daa25c734d25dc1c.png";